import { Injectable } from '@angular/core';

export interface IIndexable {
    [key: string]: any;
  }

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    public isLocalStorageAvailable: boolean = true;

    constructor(
    ) {

        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            this.isLocalStorageAvailable = true;
        } catch (e) {
            this.isLocalStorageAvailable = false;
        }

    }


    getStorageLocation(name: string) {

        if (this.isLocalStorageAvailable === true) {

            if (localStorage.getItem(name)) {

                return 'localStorage'

            } else {

                if (sessionStorage.getItem(name)) {
                    return 'sessionStorage';
                } else {
                    return undefined
                }

            }

        } else {

            if ((window as IIndexable)[name]) {
                return 'window';
            } else {
                return undefined
            }

        }

    }

    getStorageItem(name: string, checkSession?: boolean) {

        if (this.isLocalStorageAvailable === true) {

            if (localStorage.getItem(name)) {

                //convert strings to bools
                if (localStorage.getItem(name) === 'true') {
                    return true
                }

                if (localStorage.getItem(name) === 'false') {
                    return false
                }

                return localStorage.getItem(name)

            } else {
                if (checkSession) {

                    if (sessionStorage.getItem(name)) {

                        //convert strings to bools
                        if (sessionStorage.getItem(name) === 'true') {
                            return true
                        }

                        if (sessionStorage.getItem(name) === 'false') {
                            return false
                        }

                        return sessionStorage.getItem(name);

                    } else {
                        return undefined
                    }

                } else {
                    return undefined
                }
            }

        } else {

            if ((window as IIndexable)[name]) {
                return (window as IIndexable)[name];
            } else {
                return undefined
            }

        }

    }

    setStorageItem(name:string, value:any) {

        if (this.isLocalStorageAvailable === true) {

            let storageLocation: string | undefined = this.getStorageLocation(name);

            if(storageLocation != undefined){

                (window as IIndexable)[storageLocation].setItem(name, value);

            }else{
                window.localStorage.setItem(name, value);
            }


        } else {

            (window as IIndexable)[name] = value;

        }

    }

    removeStorageItem(name: string) {

        if (this.isLocalStorageAvailable === true) {

            if (this.getStorageLocation(name) == 'localStorage') {
                localStorage.removeItem(name);
            } else if (this.getStorageLocation(name) == 'sessionStorage') {
                sessionStorage.removeItem(name);
            } else {
                delete (window as IIndexable)[name];
            }

        } else {

            delete (window as IIndexable)[name];

        }

    }

}
